import { InstitutionGetCollectionByTrialCode, InstitutionCollectionResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<InstitutionCollectionResponse, InstitutionCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<InstitutionCollectionResponse, InstitutionCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useInstitutions = (trialCode?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new InstitutionGetCollectionByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useInstitutions;